import type React from 'react';
import { SellerContextProvider, useSellerState } from './useSeller';
import { useProductCatalog } from './useProductCatalog';

type SellerProviderProps = {
    children: React.ReactNode;
};

/**
 * Provides the seller POS state (cart, browse filters, totals) to the
 * product and cart panels. Mirrors the page-provider pattern — the container
 * mounts this so every panel reads shared state via `useSeller()`.
 */
export const SellerProvider: React.FC<SellerProviderProps> = ({ children }) => {
    const catalog = useProductCatalog();
    const value = useSellerState(catalog);
    return (
        <SellerContextProvider value={value}>{children}</SellerContextProvider>
    );
};
